export default __webpack_public_path__ + "static/worklogs_reports_calendar-bd416ed14f1f63615f8d0b58fb55801c.png";